import React, { Component } from "react";
import { connect } from "react-redux";

import { resetResources, setCurrentNavPage } from "Actions";
import {
  TTP_WEBTOOL_URL,
  TTP_EBOX_URL,
  TTP_ACCOUNTING_URL,
  TTP_BILLTOBOX_URL
} from "Config";

import PelletContainer from "./Pellet/PelletContainer";
import EboxContainer from "../Common/Ebox/EboxContainer";
import DashboardContainer from "./Dashboard/DashboardContainer";
import WebtoolContainer from "../Common/Webtool/WebtoolContainer";

import styles from "./ClientSpace.local.scss";
import classnames from "classnames";
import _ from "i18n";

import Header from "./Header";

export class WorkPlace extends Component {
  componentDidMount() {
    this.props.setCurrentNavPage("WORK_PLACE_PAGE");
  }

  render() {
    const { community } = this.props;

    return (
      <div className={styles.main}>
        <Header community={community} />
        <div className={styles.separator} />
        <section className="grid-x">
          <div
            className={classnames(
              "cell small-12",
              styles.section,
              styles.section12
            )}
          >
            <div className={classnames(styles.sectionHeader, styles.rightbtn)}>
              <div className={styles.headTitle}>
                <h3>{_("Stats 2019")}</h3>
                <span>{_("Accounting")}</span>
              </div>
              <a
                href={TTP_ACCOUNTING_URL}
                target="_blanck"
                className={styles.button}
              >
                {_("See more")}
              </a>
            </div>
            <div className={classnames(styles.sectionBody)}>
              <DashboardContainer community={community} />
            </div>
          </div>
        </section>
        <section className="grid-x">
          <div className={classnames(`cell small-12 large-6`, styles.section)}>
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Electronic invoices")}</h3>
                  <span>{_("Bill to box")}</span>
                </div>
                <a
                  href={TTP_BILLTOBOX_URL}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <div className={styles.sectionBody}>
                <PelletContainer community={community} />
              </div>
            </div>
          </div>
          <div className={classnames(`cell small-12 large-6`, styles.section)}>
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Letterbox")}</h3>
                  <span>{_("E-box")}</span>
                </div>
                <a
                  href={TTP_EBOX_URL}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <div className={styles.sectionBody}>
                <EboxContainer community={community} />
              </div>
            </div>
          </div>
        </section>
        <section className="grid-x">
          <div className={classnames(`cell small-12 large-6`, styles.section)}>
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Selection of useful applications")}</h3>
                  <span>{_("Web tools")}</span>
                </div>
                <a
                  href={TTP_WEBTOOL_URL}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <WebtoolContainer community={community} />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  setCurrentNavPage: page => dispatch(setCurrentNavPage(page)),
  resetResources: () => dispatch(resetResources())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkPlace);



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/index.js